import * as React from 'react';
import { Component } from 'react';
import * as PropTypes from 'prop-types';
import * as Types from './actions/actionTypes';

export interface IActionCardUIProps {
    id?: string;
    cardState?: string;
    showLeftIcon?: boolean;
    showRightIcon?: boolean;
    cardHeading?: string;
    secondaryText?: string;
    iconType?: string;
    routeTo?: string;
    onCardClick?: { (routeTo: string): void };
    handlerPostRoute?: { (): void };
    disable?: boolean;
}

export interface IActionCardUIState {
}

export default class ActionCardUI extends Component<IActionCardUIProps, IActionCardUIState> {

    static propTypes = {
        id: PropTypes.string,
        cardState: PropTypes.string,
        showLeftIcon: PropTypes.bool,
        showRightIcon: PropTypes.bool,
        cardHeading: PropTypes.string.isRequired,
        secondaryText: PropTypes.string,
        iconType: PropTypes.string,
        routeTo: PropTypes.string,
        disable: PropTypes.bool,
        isClickable: PropTypes.bool
    };

    static defaultProps = {
        showLeftIcon: true,
        showRightIcon: true,
        cardHeading: 'Card Heading Text',
        iconType: 'offer',
        cardState: 'active'
    };

    constructor(props) {
        super(props);
    }

    isClickable() {
        const { routeTo } = this.props;
        return routeTo !== null && routeTo !== undefined;
    }

    handleClick() {
        const { onCardClick, routeTo, cardState, disable, handlerPostRoute } = this.props;

        if (!disable && this.isClickable()) {
            onCardClick(routeTo);
        }
        handlerPostRoute && handlerPostRoute();
    }

    getLeftIcon(showLeftIcon: boolean, iconType: string) {
        if (!showLeftIcon) {
            return null;
        }
        else {
            return (
                <div className="left-icon-container">
                    <div className={`left-icon ${iconType}`}></div>
                </div>
            );
        }
    }

    getRightIcon(showRightIcon: boolean) {
        if (!showRightIcon) {
            return null;
        }
        else {
            return (
                <div className="right-icon-container">
                    <div className="right-icon"></div>
                </div>
            );
        }
    }

    render() {
        const {
            cardState,
            showLeftIcon,
            showRightIcon,
            cardHeading,
            secondaryText,
            iconType,
            disable,
            routeTo,
            onCardClick
        } = this.props;

        const leftIcon = this.getLeftIcon(showLeftIcon, iconType);
        const rightIcon = this.getRightIcon(showRightIcon);

        const className = `dr-ui-actioncard${this.isClickable() ? '' : ' dr-ui-leaf'}`;

        return (
            <div id={this.props.id} className={className} onClick={this.handleClick.bind(this)}>
                <div className={`${cardState}${disable ? ' disabled' : ''}`}>
                    {leftIcon}
                    <div className="card-text">
                        <div className="header">{cardHeading}</div>
                        <div className="secondary">{secondaryText}</div>
                    </div>
                    {rightIcon}
                </div>
            </div>
        );
    }
}
